import React from 'react';
import classNames from 'classnames';

import Checkmark from './Assets/checkmark.svg'
import CheckmarkCompleted from './Assets/checkmark-completed.svg'

const ProgressItem = (props) => {

  const checkMark = props.active || props.completed ? CheckmarkCompleted : Checkmark;

  const classes = classNames({
    active: props.active,
    completed: props.completed
  });

  return <li className={classes}>
    <a href="#!" onClick={(e) => {
      e.preventDefault();
      props.click(props.type);
    }}>
      <span className="checkmark">
        <img src={checkMark} alt="checkmark completed" />
      </span>
      <span className="label">{props.label}</span>
    </a>
  </li>
};

export default ProgressItem;